import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Admin from "../../../../services/admin";
import User from "../../../../services/user";
import Session from "../../utils/session";
import { FiltersRow, InputFilter, InputRow, SelectRow } from "../../utils/table-utils";
import MoneyFormatter from "../../utils/money-formatter";
import { DateHelperFilter, PerPageFilter, TableFormatter } from "../../utils/form-utils";
import PopupLayout from "../site/popup-layout";

import * as U from "../../desktop-templates/menu-user";
import * as I from "../../utils/icons";

export default class DashboardPage extends Component {
    state = {
        response: {},
        tabs: {
            username: null,
            current: '',
            list: {}
        }
    };

    componentWillMount() {
        this.state.tabs.current = this.props.tab || 'newuser';
        this.state.tabs.list = {
            newuser: {
                label: window.Translation(msg`Nuovo Utente`),
                description: window.Translation(msg`Iscrivi nuovo utente`)
            },
            userlist: {
                label: window.Translation(msg`Lista Utenti`),
                description: window.Translation(msg`Elenco utenti iscritti`)
            },
            transfers: {
                label: window.Translation(msg`Trasferimenti`),
                description: window.Translation(msg`Trasferimenti finanziari utenti`)
            },
            transactions: {
                label: window.Translation(msg`Movimenti Utenti`),
                description: window.Translation(msg`Elenco movimenti finanziari utenti`)
            }
        };
    }

    switchTabs(newtab) {
        this.state.tabs.username = null;
        this.state.tabs.current = newtab;
        this.setState(this.state);
    }

    render() {
        return <div>
            <U.SubTabsContainer>
                {Object.entries(this.state.tabs.list).map(
                    ([key, item]) => <U.Tab selected={key === this.state.tabs.current} onClick={e => this.switchTabs(key)}>{item.label}</U.Tab>
                )}
            </U.SubTabsContainer>
            <div class="user-menu-headermain-text-color p-2 text-base font-bold m-3 capitalize rounded">{this.state.tabs.list[this.state.tabs.current].description}</div>
            {this.state.tabs.current === 'newuser' && <NewUserForm />}
            {this.state.tabs.current === 'transfers' && <UserTransfers />}
            {this.state.tabs.current === 'userlist' && <UserList openTransactionsClick={username => {
                this.state.tabs.username = username;
                this.state.tabs.current = 'transactions';
                this.setState(this.state);
            }} />}
            {this.state.tabs.current === 'transactions' && <UserTransactions username={this.state.tabs.username} />}
        </div>;
    }
}

export class NewUserForm extends Component {
    state = {
        done: false,
        transfer: false,
        input: {},
        steps: {
            current: null,
            available: [],
            completed: []
        },
        countries: []
    };

    componentWillMount() {
        this.initformvars();
        this.state.steps.current = 0;
        this.state.steps.available = [
            window.Translation(msg`Dettagli Account`),
            window.Translation(msg`Informazioni di Residenza`),
            window.Translation(msg`Dati di Nascita`),
            window.Translation(msg`Saldo Iniziale`)
        ];

        //> Precarichiamo la lista dei paesi disponibili che ci servono nelle fasi 2 e 3
        Admin.fetchCountries().then(c => this.state.countries = c);
    }

    resetForm() {
        this.state.done = false;
        this.state.transfer = false;
        this.state.steps.current = 0;
        this.state.steps.completed = [];
        this.initformvars();
        this.setState(this.state);
    }

    initformvars() {
        this.state.input = {
            username: '',
            email: '',
            password: '',
            confpass: '',
            firstname: '',
            lastname: '',

            residence_country: '',
            residence_state: '',
            residence_city: '',
            residence_cap: '',
            residence_address: '',
            residence_housenumber: '',

            birth_country: '',
            birth_state: '',
            birth_city: '',
            birth_date: '',

            amount: 0.00,
        };
    }

    cleanupPhoneNumberUsername(username) {
        const numbersOnly = username.replace(/[^0-9]/g, '');
        const noInternationalPrefix = numbersOnly.replace(/^(251)?(0)?/, '');
        return noInternationalPrefix;
    }

    submitAccountData() {
        Admin.createUser(
            this.cleanupPhoneNumberUsername(this.state.input.username),
            this.state.input.password,
            this.state.input.confpass,
            this.state.input.email,
            null,
            {
                'preferred-currency': User.data.account.currency,
                currency: User.data.account.currency,
                sesso: 'm',
                nome: this.state.input.firstname,
                cognome: this.state.input.lastname,
                nascita_data: this.state.input.birth_date,
                nascita_nazione: this.state.input.birth_country,
                nascita_provincia: this.state.input.birth_state,
                nascita_luogo: this.state.input.birth_city,
                residenza_nazione: this.state.input.residence_country,
                residenza_provincia: this.state.input.residence_state,
                residenza_citta: this.state.input.residence_city,
                residenza_cap: this.state.input.residence_cap,
                residenza_indirizzo: this.state.input.residence_address,
                residenza_numcivico: this.state.input.residence_housenumber
            }
        )
            .then(user => {
                this.state.done = user;
                this.state.done.amount = 0;

                if (this.state.input.amount == 0) {

                    //> Se non ci sono trasferimenti monetari da fare completiamo qui la procedura
                    !!this.props.onComplete && this.props.onComplete(user);
                    this.setState(this.state);

                } else {

                    //> Altrimenti aspettiamo l'esito del trasferimento finanziario
                    Admin.userTransfer(
                        Session.fetch('id'),
                        user.idstruttura,
                        user.idstruttura,
                        this.state.input.amount,
                        user.preferred_currency,
                        'Movimentazione manuale per creazione conto gioco'
                    )
                        .catch(e => {
                            this.state.transfer = e;
                            console.error(e);
                        })
                        .then(response => {
                            this.state.done.amount = this.state.input.amount;
                        })
                        .finally(() => {
                            //> e solo quando questa promise è terminata mostriamo l'esito
                            !!this.props.onComplete && this.props.onComplete(user);
                            this.setState(this.state);
                        });

                }
            })
            .catch(e => {
                alert(window.Translation(msg`Si sono verificati dei problemi con la creazione dell'utente. Si prega di riprovare.`));
                console.error(e);
            });
    }

    switchStep(stepindex) {
        //> Se mi chiedono di avanzare OLRE il numero di steps disponibili significa che hanno confermato l'invio dei dati
        if (stepindex >= this.state.steps.available.length) {
            this.submitAccountData();
            return;
        }

        if (this.state.steps.completed.indexOf(this.state.steps.current) === -1) {
            this.state.steps.completed.push(this.state.steps.current);
        }

        this.state.steps.current = stepindex;
        this.setState(this.state);
    }

    renderFormSteps() {
        const maxIndex = this.state.steps.available.length - 1;
        const isCompleted = step => this.state.steps.completed.indexOf(step) !== -1;
        return <div class="w-full flex items-center justify-center">
            {this.state.steps.available.map(
                (step, i) => <FormStepLabel selected={this.state.steps.current == i} completed={isCompleted(i)} id={i + 1} name={step} />
            )}
        </div>;
    }

    render() {
        return <div class="px-3">
            {!!this.state.done && <div>
                <FiltersRow>
                    <div class="py-1 px-2 w-1/2">
                        <div>
                            <div><span><Trans>User ID</Trans></span></div>
                            <div class="px-2 py-1 rounded border bg-white flex-1 w-full text-link-500">
                                {this.state.done.idstruttura}
                            </div>
                        </div>
                    </div>
                    <div class="py-1 px-2 w-1/2">
                        <div>
                            <div><span><Trans>Username</Trans></span></div>
                            <div class="px-2 py-1 rounded border bg-white flex-1 w-full text-link-500">
                                {this.state.done.username}
                            </div>
                        </div>
                    </div>
                </FiltersRow>
                <FiltersRow>
                    <div class="py-1 px-2 w-1/2">
                        <div>
                            <div><span><Trans>Email</Trans></span></div>
                            <div class="px-2 py-1 rounded border bg-white flex-1 w-full text-link-500">
                                {this.state.input.email}
                            </div>
                        </div>
                    </div>
                    <div class="py-1 px-2 w-1/2">
                        <div>
                            <div><span><Trans>Password</Trans></span></div>
                            <div class="px-2 py-1 rounded border bg-white flex-1 w-full text-link-500">
                                {this.state.input.password}
                            </div>
                        </div>
                    </div>
                </FiltersRow>
                <FiltersRow>
                    <div class="py-1 px-2 w-1/2">
                        <div>
                            <div><span><Trans>Valuta</Trans></span></div>
                            <div class="px-2 py-1 rounded border bg-white flex-1 w-full text-link-500">
                                {this.state.done.preferred_currency}
                            </div>
                        </div>
                    </div>
                    <div class="py-1 px-2 w-1/2">
                        <div>
                            <div><span><Trans>Disponibilità</Trans></span></div>
                            <div class="px-2 py-1 rounded border bg-white flex-1 w-full text-link-500">
                                <MoneyFormatter value={this.state.done.amount} currency={this.state.done.preferred_currency} />
                            </div>
                        </div>
                    </div>
                </FiltersRow>
                <p class="p-3 font-bold text-center main-color">
                    <Trans>Utente creato con successo!</Trans>
                </p>
                {this.state.transfer !== false && <p class="p-3 font-bold text-center warning-color">
                    <Trans>Non è stato possibile effettuare il deposito iniziale a causa di un errore tecnico: {this.state.transfer}</Trans>
                </p>}
                <FiltersRow class="pt-5 px-5 items-center justify-center">
                    <input
                        type="button"
                        class="px-4 py-2 sm:ml-5 bg-kobaaccent-400 text-black rounded m-auto"
                        value={window.Translation(msg`Continua`)}
                        onClick={e => this.resetForm()}
                    />
                </FiltersRow>
            </div>}

            {!this.state.done && <Fragment>
                <div class="text-xs mb-3">
                    {this.renderFormSteps()}
                </div>

                <div class="px-4">
                    <form id="step-form" method="post" onSubmit={e => { e.preventDefault(); !!e.target.checkValidity() && this.switchStep(this.state.steps.current + 1); }}>
                        {/* Form - Step 1 */}
                        {this.state.steps.current === 0 && <Fragment>
                            <FiltersRow>
                                <InputRow
                                    label={<span>{window.Translation(msg`Phone Number`)}<span class="warning-color">*</span></span>}
                                    type="text"
                                    onInput={e => {
                                        this.state.input.username = e.target.value;
                                        this.setState({});
                                    }}
                                    value={this.state.input.username}
                                    required={true}
                                />
                                <InputRow
                                    label={<span>{window.Translation(msg`Email`)}</span>}
                                    type="email"
                                    onInput={e => {
                                        this.state.input.email = e.target.value;
                                        this.setState({});
                                    }}
                                    value={this.state.input.email}
                                />
                            </FiltersRow>
                            <FiltersRow>
                                <InputRow
                                    id="password"
                                    label={<span>{window.Translation(msg`Password`)}<span class="warning-color">*</span></span>}
                                    type="password"
                                    onInput={e => {
                                        e.target.setCustomValidity('');
                                        this.state.input.password = e.target.value;

                                        if (this.state.input.password.length < 6) {
                                            e.target.setCustomValidity(window.Translation(msg`La password deve avere 6 o più caratteri`));
                                        }

                                        this.setState({});
                                    }}
                                    value={this.state.input.password}
                                    required={true}
                                />
                                <InputRow
                                    id="confpass"
                                    label={<span>{window.Translation(msg`Conferma Password`)}<span class="warning-color">*</span></span>}
                                    type="password"
                                    onInput={e => {
                                        e.target.setCustomValidity('');
                                        this.state.input.confpass = e.target.value;

                                        if (this.state.input.confpass !== this.state.input.password) {
                                            e.target.setCustomValidity(window.Translation(msg`Le due password devono coincidere`));
                                        }

                                        this.setState({});
                                    }}
                                    value={this.state.input.confpass}
                                    required={true}
                                />
                            </FiltersRow>
                            <FiltersRow>
                                <InputRow
                                    label={<span>{window.Translation(msg`Nome`)}</span>}
                                    type="text"
                                    onInput={e => {
                                        this.state.input.firstname = e.target.value;
                                        this.setState({});
                                    }}
                                    value={this.state.input.firstname}
                                />
                                <InputRow
                                    label={<span>{window.Translation(msg`Cognome`)}</span>}
                                    type="text"
                                    onInput={e => {
                                        this.state.input.lastname = e.target.value;
                                        this.setState({});
                                    }}
                                    value={this.state.input.lastname}
                                />
                            </FiltersRow>
                        </Fragment>}

                        {/* Form - Step 2 */}
                        {this.state.steps.current === 1 && <Fragment>
                            <FiltersRow>
                                <SelectRow
                                    label={<span>{window.Translation(msg`Paese Di Residenza`)}</span>}
                                    onChange={e => {
                                        this.state.input.residence_country = e.currentTarget.value;
                                        this.setState({});
                                    }}
                                >
                                    <option value=""><Trans>Scegli un paese...</Trans></option>
                                    {this.state.countries.map(
                                        country => <option value={country.code} selected={country.code === this.state.input.residence_country}>{country.name}</option>
                                    )}
                                </SelectRow>
                                <InputRow
                                    label={<span>{window.Translation(msg`Stato/Provincia/Regione`)}</span>}
                                    type="text"
                                    onInput={e => {
                                        this.state.input.residence_state = e.target.value;
                                        this.setState({});
                                    }}
                                    value={this.state.input.residence_state}
                                />
                            </FiltersRow>
                            <FiltersRow>
                                <FiltersRow>
                                    <InputRow
                                        label={<span>{window.Translation(msg`Città Di Residenza`)}</span>}
                                        type="text"
                                        boxclass="py-1 px-2 w-4/5"
                                        onInput={e => {
                                            this.state.input.residence_city = e.target.value;
                                            this.setState({});
                                        }}
                                        value={this.state.input.residence_city}
                                    />
                                    <InputRow
                                        label={<span>{window.Translation(msg`CAP`)}</span>}
                                        type="text"
                                        boxclass="py-1 px-2 w-1/5"
                                        onInput={e => {
                                            this.state.input.residence_cap = e.target.value;
                                            this.setState({});
                                        }}
                                        value={this.state.input.residence_cap}
                                    />
                                </FiltersRow>
                                <FiltersRow>
                                    <InputRow
                                        label={<span>{window.Translation(msg`Indirizzo Di Residenza`)}</span>}
                                        type="text"
                                        boxclass="py-1 px-2 w-4/5"
                                        onInput={e => {
                                            this.state.input.residence_address = e.target.value;
                                            this.setState({});
                                        }}
                                        value={this.state.input.residence_address}
                                    />
                                    <InputRow
                                        label={<span>{window.Translation(msg`N.`)}</span>}
                                        type="text"
                                        boxclass="py-1 px-2 w-1/5"
                                        onInput={e => {
                                            this.state.input.residence_housenumber = e.target.value;
                                            this.setState({});
                                        }}
                                        value={this.state.input.residence_housenumber}
                                    />
                                </FiltersRow>
                            </FiltersRow>
                        </Fragment>}

                        {/* Form - Step 3 */}
                        {this.state.steps.current === 2 && <Fragment>
                            <FiltersRow>
                                <SelectRow
                                    label={<span>{window.Translation(msg`Paese Di Nascita`)}</span>}
                                    onChange={e => {
                                        this.state.input.birth_country = e.currentTarget.value;
                                        this.setState({});
                                    }}
                                >
                                    <option value=""><Trans>Scegli un paese...</Trans></option>
                                    {this.state.countries.map(
                                        country => <option value={country.code} selected={country.code === this.state.input.birth_country}>{country.name}</option>
                                    )}
                                </SelectRow>
                                <InputRow
                                    label={<span>{window.Translation(msg`Stato/Provincia/Regione Di Nascita`)}</span>}
                                    type="text"
                                    onInput={e => {
                                        this.state.input.birth_state = e.target.value;
                                        this.setState({});
                                    }}
                                    value={this.state.input.birth_state}
                                />
                            </FiltersRow>
                            <FiltersRow>
                                <InputRow
                                    label={<span>{window.Translation(msg`Città Di Nascita`)}</span>}
                                    type="text"
                                    onInput={e => {
                                        this.state.input.birth_city = e.target.value;
                                        this.setState({});
                                    }}
                                    value={this.state.input.birth_city}
                                />
                                <InputRow
                                    label={<span>{window.Translation(msg`Data Di Nascita`)}</span>}
                                    type="date"
                                    onInput={e => {
                                        this.state.input.birth_date = e.target.value;
                                        this.setState({});
                                    }}
                                    value={this.state.input.birth_date}
                                />
                            </FiltersRow>
                        </Fragment>}

                        {/* Form - Step 4 */}
                        {this.state.steps.current === 3 && <FiltersRow>
                            <div class="py-1 px-2 w-1/2">
                                <div>
                                    <div><span><Trans>Il Mio Saldo</Trans></span></div>
                                    <div class="px-2 py-1 rounded border bg-white flex-1 w-full text-link-500">
                                        <MoneyFormatter value={Session.fetch('account').balance} />
                                    </div>
                                </div>
                            </div>
                            <InputRow
                                label={<span>{window.Translation(msg`Saldo Utente`)}<span class="warning-color">*</span></span>}
                                type="number"
                                min="0.00"
                                max={Session.fetch('account').balance}
                                step="1.00"
                                onInput={e => {
                                    this.state.input.amount = e.target.value;
                                    this.setState({});
                                }}
                                value={this.state.input.amount}
                                required={true}
                            />
                        </FiltersRow>}

                        <FiltersRow class="pt-5 gap-2 px-5 flex justify-between w-full">
                            <div>{this.state.steps.current > 0 && <Fragment>
                                <input
                                    type="button"
                                    class="px-4 py-2 bg-blue-whale-600 text-slate-100 rounded"
                                    value={window.Translation(msg`Indietro`)}
                                    onClick={e => this.switchStep(this.state.steps.current - 1)}
                                />
                            </Fragment>}</div>
                            <input
                                id="next-step-button"
                                type="submit"
                                class="px-4 py-2 bg-kobaaccent-400 text-black rounded"
                                value={window.Translation(msg`Avanti`)}
                            />
                        </FiltersRow>
                    </form>
                    <p class="italic text-xxs p-5">
                        <Trans>I campi col segno <span class="warning-color">*</span> sono obbligatori</Trans>
                    </p>
                </div>
            </Fragment>}
        </div>;
    }
}

function FormStepLabel({ selected, completed, id, name }) {
    return <a
        href="javascript:void(0);"
        class={"flex gap-1 items-center px-2 " + (selected ? 'text-blue-whale-600' : completed ? 'text-green-600' : 'text-slate-700')}
    >
        <div class={"block leading-tight text-center shrink-0 p-1 rounded-full h-6 w-6 border " + (selected ? 'border-blue-whale-600' : completed ? 'border-green-600' : 'border-slate-700')}>{id}</div>
        <span class={"block "}>{name}</span>
    </a>
}

export class UserTransfers extends Component {
    transfer = null;
    state = {
        input: {},
        transferstatus: null,
        usernameTransactionMode: true
    }

    componentWillMount() {
        this.resetForm();
        this.setState(this.state);
    }

    resetForm() {
        this.state.input = {
            account: '',
            transfertype: '1',
            reason: '',
            amount: ''
        };
    }

    cleanupPhoneNumberUsername(username) {
        const numbersOnly = username.replace(/[^0-9]/g, '');
        const noInternationalPrefix = numbersOnly.replace(/^(251)?(0)?/, '');
        return noInternationalPrefix;
    }

    runTransfer(form) {
        //> Verifico che sia stata selezionata una user
        if (this.state.input.account === '') {
            document
                .getElementById('accounts-selection')
                .setCustomValidity(window.Translation(msg`Devi selezionare un account prima di poter procedere`));
        }

        //> Se fallisco i controlli di validità del form esco
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        if (this.transfer != null)
            return;

        this.state.transferstatus = null;
        this.setState(this.state);
        //> Altrimenti va tutto bene, eseguo il trasferimento
        // Ho creato Admin.usernameUserTransfer(Session.fetch('id'), USERNAME, amount, currency, note)
        const transferReq = this.state.usernameTransactionMode ? Admin.usernameUserTransfer(
            Session.fetch('id'),
            this.cleanupPhoneNumberUsername(this.state.input.account),
            Math.abs(this.state.input.amount) * (this.state.input.transfertype === '1' ? 1 : -1),
            Session.fetch('account').currency,
            this.state.input.reason
        ) : Admin.userTransfer(
            Session.fetch('id'),
            this.state.input.account,
            this.state.input.account,
            Math.abs(this.state.input.amount) * (this.state.input.transfertype === '1' ? 1 : -1),
            Session.fetch('account').currency,
            this.state.input.reason
        );

        transferReq
            .then(response => {
                //console.info('then', response);
                this.resetForm();
                this.state.transferstatus = true;
                this.setState(this.state);
            })
            .catch(e => {
                this.state.transferstatus = e;
                this.setState(this.state);
            })
            .then(() => {
                this.transfer = null;
            });
    }

    render() {
        return <div class="px-3">

            {this.state.transferstatus !== null && this.state.transferstatus !== true && <p class="p-3 font-bold text-center warning-color">
                <Trans>Errore:</Trans>
                &nbsp;
                {this.state.transferstatus}
            </p>}

            {this.state.transferstatus === true && <p class="p-3 font-bold text-center main-color">
                <Trans>Trasferimento andato a buon fine</Trans>
            </p>}

            <form method="post" onSubmit={e => { e.preventDefault(); this.runTransfer(e.target); }}>
                <FiltersRow>
                    <label class="mx-px px-2">
                        <span class="block text-xs"><Trans>Your Balance</Trans></span>
                        <InputFilter
                            type="number"
                            step="0.01"
                            disabled={true}
                            class="w-40 px-2 py-1 leading-6 rounded border"
                            value={parseFloat(Session.fetch('account').balance).toFixed(2)}
                        />
                    </label>
                </FiltersRow>
                <FiltersRow>
                    {this.state.usernameTransactionMode ? null : <SelectRow
                        id="accounts-selection"
                        label={<span>{window.Translation(msg`Account`)}<span className="warning-color">*</span></span>}
                        onChange={e => {
                            e.target.setCustomValidity('');
                            this.state.input.account = e.currentTarget.value;
                            this.setState({});
                        }}
                    >
                        <option value="" selected={this.state.input.account == ''}><Trans>Scegli un utente...</Trans></option>
                        {!!Session.fetch('users') && Session.fetch('users').map(
                            user => <option value={user.idaccounts} selected={this.state.input.account === user.idaccounts}>{user.username} ({parseFloat(user.saldo).toFixed(2)})</option>
                        )}
                    </SelectRow>}
                    {!this.state.usernameTransactionMode ? null : <InputRow
                        id="accounts-selection"
                        label={<span>{window.Translation(msg`Account`)}<span className="warning-color">*</span></span>}
                        placeholder="+251 (0)"
                        onChange={e => {
                            e.target.setCustomValidity('');
                            this.state.input.account = e.currentTarget.value;
                            this.setState({});
                        }}
                    />}

                    <SelectRow
                        label={<span>{window.Translation(msg`Tipo di Operazione`)}<span className="warning-color">*</span></span>}
                        onChange={e => {
                            this.state.input.transfertype = e.currentTarget.value;
                            this.setState({});
                        }}
                    >
                        <option value="1" selected={this.state.input.transfertype === '1'}><Trans>Deposito</Trans></option>
                        <option value="2" selected={this.state.input.transfertype === '2'}><Trans>Prelievo</Trans></option>
                    </SelectRow>
                </FiltersRow>
                <FiltersRow>
                    <InputRow
                        label={<span>{window.Translation(msg`Motivo`)}</span>}
                        type="text"
                        onInput={e => {
                            this.state.input.reason = e.target.value;
                            this.setState({});
                        }}
                        value={this.state.input.reason}
                    />
                    <InputRow
                        label={<span>{window.Translation(msg`Importo`)}<span className="warning-color">*</span></span>}
                        type="number"
                        min="0.00"
                        step="0.01"
                        onInput={e => {
                            this.state.input.amount = e.target.value;
                            this.setState({});
                        }}
                        value={this.state.input.amount}
                        required={true}
                    />
                </FiltersRow>
                <FiltersRow class="pt-5 px-5 justify-end">
                    <input
                        id="next-step-button"
                        type="submit"
                        class="px-4 py-2 sm:ml-5 bg-kobaaccent-400 text-black rounded m-auto"
                        value={window.Translation(msg`Trasferisci Fondi`)}
                    />
                </FiltersRow>
            </form>
            <p class="italic text-xxs p-5">
                <Trans>I campi col segno <span class="warning-color">*</span> sono obbligatori</Trans>
            </p>
        </div>;
    }
}

export class UserList extends Component {
    state = {
        perPage: 10,
        page: 1,
        response: {},
        searchusername: ''
    };

    componentWillMount() {
        this.performSearch();
    }

    changePage(newpage) {
        //> Controllo di sicurezza per non fare richieste inutili
        if (!!Object.values(this.state.response)) {
            //> Esco se newpage è inferiore a 1 o maggiore del numero massimo di pagine possibili
            if (
                newpage < 1
                || newpage === this.state.page
                || newpage > Math.ceil(this.state.response.totalrecords / this.state.perPage)) {
                return;
            }
        }

        this.state.page = newpage;
        this.performSearch();
    }

    findUsernameFilter(user) {
        return this.state.searchusername === ''
            || user.username.toLowerCase().indexOf(this.state.searchusername.toLowerCase()) !== -1;
    }

    performSearch() {
        const lowlimit = (this.state.page * this.state.perPage) - this.state.perPage;
        const alldata = !!Session.fetch('users') ?
            Session.fetch('users').filter(row => this.findUsernameFilter(row))
            : [];
        const data = alldata.slice(lowlimit, lowlimit + this.state.perPage);
        this.setState({
            response: {
                totalrecords: alldata.length,
                recordperpage: this.state.perPage,
                page: this.state.page,
                lowlimit,
                data
            }
        });
    }

    tableColumns() {
        return [
            <strong class="block text-left body-bg-color"><Trans>ID</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Username</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Email</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Saldo</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Totale Scommesso</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Totale Vinto</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Data Iscrizione</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Movimenti</Trans></strong>
        ];
    }

    tableDataMapper(row) {
        const createdDate = new Date(row.created);
        return [
            <span class="block text-left">{row.idaccounts}</span>,
            <span class="block text-left font-bold">{row.username}</span>,
            <span class="block text-center">{row.email}</span>,
            <span class="block text-right"><MoneyFormatter value={row.saldo} currency={row.currency} /></span>,
            <span class="block text-right"><MoneyFormatter value={row.tot_in} currency={row.currency} /></span>,
            <span class="block text-right"><MoneyFormatter value={row.tot_out} currency={row.currency} /></span>,
            <span class="block text-right">
                {createdDate.toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' })}
                &nbsp;
                {createdDate.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })}
            </span>,
            <span class="block text-center">
                <a href="javascript:void(0);" onClick={e => !!this.props.openTransactionsClick && this.props.openTransactionsClick(row.username)}>
                    <i class="fa-solid fa-clipboard-list" />
                </a>
            </span>
        ];
    }

    render() {
        return <div class="px-3">
            <FiltersRow class="p-2 text-sm items-end justify-center">
                <label class="mx-px px-2">
                    <span class="block text-xs"><Trans>Username</Trans></span>
                    <InputFilter
                        type="text"
                        class="w-40 px-2 py-1 leading-6 rounded border"
                        value={this.state.searchusername}
                        onInput={e => this.setState({ searchusername: e.target.value })}
                    />
                </label>
                <PerPageFilter
                    perPage={this.state.perPage}
                    pageList={[10, 20, 30, 50, 100]}
                    onInput={
                        ({ perPage }) => {
                            this.state.perPage = perPage;
                            this.setState(this.state);
                        }
                    }
                />
                <a href="javascript:void(0);" class="px-4 py-2 sm:ml-5 bg-kobaaccent-400 text-black rounded" onClick={e => this.performSearch()}>
                    <Trans>Avvia Ricerca</Trans> <I.SearchIcon class="h-3 inline-block" />
                </a>
            </FiltersRow>
            <div class="text-xs mt-3">
                <TableFormatter
                    {...this.state.response}
                    style="font-family:'Arial rounded', Arial, sans-serif;"
                    columns={this.tableColumns()}
                    rowClass={'hover:bg-gray-200 border-b'}
                    cellClass={'leading-7'}
                    rowDataMapper={this.tableDataMapper.bind(this)}
                    onNavigation={(newpage, newlowlimit) => this.changePage(newpage)}
                />
            </div>
        </div>;
    }
}

export class UserTransactions extends Component {
    state = {
        dateFilter: {
            helperValue: 0,
            dateStartValue: null,
            dateEndValue: null
        },
        idplayer: null,
        username: null,
        perPage: 10,
        page: 1,
        response: {}
    };

    componentWillMount() {
        this.state.idplayer = !!this.props.idplayer ? this.props.idplayer : null;
        this.state.username = !!this.props.username ? this.props.username : null;
        this.state.dateFilter.helperValue = 1; // Oggi
        this.state.dateFilter.dateStartValue = new Date().toLocaleDateString('en-CA');
        this.state.dateFilter.dateEndValue = this.state.dateFilter.dateStartValue;
        this.performSearch();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.state.idplayer = !!nextProps.idplayer ? nextProps.idplayer : null;
        this.state.username = !!nextProps.username ? nextProps.username : null;
    }

    changePage(newpage) {
        //> Controllo di sicurezza per non fare richieste inutili
        if (!!Object.values(this.state.response)) {
            //> Esco se newpage è inferiore a 1 o maggiore del numero massimo di pagine possibili
            if (
                newpage < 1
                || newpage === this.state.page
                || newpage > Math.ceil(this.state.response.totalrecords / this.state.perPage)) {
                return;
            }
        }

        this.state.page = newpage;
        this.performSearch();
    }

    performSearch() {
        Admin.userTransactions({
            idplayer: this.state.idplayer,
            username: this.state.username,
            fromDate: this.state.dateFilter.dateStartValue,
            toDate: this.state.dateFilter.dateEndValue,
            page: this.state.page,
            perPage: this.state.perPage,
            isManager: !!Session.fetch('club') || !!Session.fetch('manager')
        })
            .then(response => this.setState({
                response: {
                    totalrecords: response._info.records,
                    recordperpage: this.state.perPage,
                    page: this.state.page,
                    lowlimit: (this.state.page * this.state.perPage) - this.state.perPage,
                    data: response.data
                }
            }));
    }

    tableColumns() {
        return [
            <strong class="block text-left body-bg-color"><Trans>ID</Trans></strong>,
            <strong class="block text-left body-bg-color"><Trans>Username</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Data</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Descrizione</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Importo</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Saldo</Trans></strong>
        ];
    }

    tableDataMapper(row) {
        const label = !!row['is-sender'] ? 'sender' : 'receiver';
        return [
            <span class="block px-2 text-left">{row.idtransazione}</span>,
            <span class="block px-2 text-left"><strong>{row[label].company}</strong></span>,
            <span class="block px-2 text-center">
                {new Date(row.ts * 1000).toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' })}
                &nbsp;
                {new Date(row.ts * 1000).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })}
            </span>,
            <span class="block px-2 text-center">{row.description.rawmessage || row.description.message}</span>,
            <span class={'block px-2 text-right ' + (parseFloat(row.amount) < 0 ? 'text-red-600' : 'text-green-600')}>
                {row.wallet_type == "bonus" ? '🎁' : ''}
                <MoneyFormatter value={row.amount} currency={row.currency} />
            </span>,
            <span class="block px-2 text-right"><MoneyFormatter value={row['new_' + label + '_balance']} currency={row.currency} /></span>
        ];
    }

    render() {
        return <div class="px-3">
            <FiltersRow class="p-2 text-sm items-end justify-center">
                <DateHelperFilter
                    {...this.state.dateFilter}
                    onInput={
                        (dateFilter) => {
                            this.state.dateFilter = dateFilter;
                            this.setState(this.state);
                        }
                    }
                />
                <label class="mx-px px-2">
                    <span class="block text-xs"><Trans>Username</Trans></span>
                    <InputFilter
                        type="text"
                        class="w-40 px-2 py-1 leading-6 rounded border"
                        value={this.state.username}
                        onInput={e => this.setState({ username: e.target.value })}
                    />
                </label>
                <PerPageFilter
                    perPage={this.state.perPage}
                    pageList={[10, 20, 30, 50, 100]}
                    onInput={
                        ({ perPage }) => {
                            this.state.perPage = perPage;
                            this.setState(this.state);
                        }
                    }
                />
                <a href="javascript:void(0);" class="px-4 py-2 sm:ml-5 bg-kobaaccent-400 text-black rounded" onClick={e => this.performSearch()}>
                    <Trans>Avvia Ricerca</Trans> <I.SearchIcon class="h-3 inline-block" />
                </a>
            </FiltersRow>
            <div class="text-xs mt-3">
                <TableFormatter
                    {...this.state.response}
                    style="font-family:'Arial rounded', Arial, sans-serif;"
                    columns={this.tableColumns()}
                    cellClass={'leading-7'}
                    rowClass={'hover:bg-gray-200 border-b'}
                    rowDataMapper={this.tableDataMapper.bind(this)}
                    onNavigation={(newpage, newlowlimit) => this.changePage(newpage)}
                />
            </div>
        </div>;
    }
}

export let UserTransactionPopup = username => window.open(
    '/admin/transactions/player/' + encodeURIComponent(username),
    'userTransactionsWindow',
    'width=1100,height=600,scrollbars=yes'
);

export class UserTransactionHistoryPopup extends Component {
    render() {
        return <PopupLayout>
            <div class="px-0 py-3 bg-white border text-gray-900">
                <div class="py-2 text-lg text-center"><Trans>Storico Movimenti</Trans></div>
                <UserTransactions username={this.props.username} />
            </div>
        </PopupLayout>;
    }
}